import { Component, DestroyRef, HostListener, computed, inject, signal } from '@angular/core';
import { SectionHeadingComponent } from '../../ui/section-heading/section-heading.component';

@Component({
  selector: 'app-dj-control',
  standalone: true,
  imports: [SectionHeadingComponent],
  templateUrl: './dj-control.component.html',
  styleUrl: './dj-control.component.scss',
})
export class DjControlComponent {
  phones = [
    { n: 1, title: 'Włązca grę', text: 'Uruchamia grę i pokazuje kod QR na dużym ekranie.', placeholder: 'Ekran - start gry' },
    { n: 2, title: 'Steruje rundą', text: 'Przełącza kolejne pytania i odlicza czas jednym kliknięciuem.', placeholder: 'Ekran - sterowanie pytaniem' },
    { n: 3, title: 'Pokazuje wyniki', text: 'Pokazuje ranking na dużym ekran, a sala reaguje razem.', placeholder: 'Ekran - ranking' },
  ];

  readonly index = signal(0);
  readonly isMobile = signal(false);

  /** Transform tylko na mobile; desktop pokazuje wszystkie slajdy obok siebie. */
  readonly trackTransform = computed(() =>
    this.isMobile() ? `translateX(${-this.index() * 100}%)` : 'none',
  );

  private mql = window.matchMedia('(max-width: 720px)');

  constructor() {
    const sync = (e: MediaQueryListEvent | MediaQueryList) => this.isMobile.set(e.matches);
    sync(this.mql);
    const handler = (e: MediaQueryListEvent) => sync(e);
    this.mql.addEventListener('change', handler);
    inject(DestroyRef).onDestroy(() => this.mql.removeEventListener('change', handler));
  }

  go(i: number) {
    this.index.set(Math.max(0, Math.min(i, this.phones.length - 1)));
  }

  prev() {
    this.go(this.index() - 1);
  }

  next() {
    this.go(this.index() + 1);
  }

  // Swipe / drag — pointer events (mysz, dotyk, rysik)
  private dragging = false;
  private startX = 0;

  onPointerDown(e: PointerEvent) {
    if (!this.isMobile()) return;
    this.dragging = true;
    this.startX = e.clientX;
  }

  @HostListener('window:pointerup', ['$event'])
  onPointerUp(e: PointerEvent) {
    if (!this.dragging) return;
    this.dragging = false;
    const dx = e.clientX - this.startX;
    if (Math.abs(dx) > 40) {
      dx < 0 ? this.next() : this.prev();
    }
  }
}
